import React from 'react';
import useSelectTextColor from '../../../../common/hooks/useSelectTextColor';
import styles from './FullWidthImageContent.module.scss';

function FullWidthImageContent({ data }) {
    const backgroundColor = data?.background_color || '#ffffff';
    const selectTextColor = useSelectTextColor();
    const textColor = selectTextColor(backgroundColor);
    const titleColor = data?.title_text_color || textColor;

    return (
        <section
            className={styles.section}
            style={{
                '--full_width_section_bg': backgroundColor,
                '--full_width_section_text': textColor,
            }}
        >
            {(data?.title || data?.content) && (
                <div className={`container ${styles.contentWrap}`}>
                    {data?.title && (
                        <h2 style={{ color: titleColor }}>{data.title}</h2>
                    )}
                    {data?.content && (
                        <div
                            className={styles.content}
                            dangerouslySetInnerHTML={{ __html: data.content }}
                        />
                    )}
                </div>
            )}
            {data?.image && (
                <div className={styles.imageWrap}>
                    <img src={data.image} alt={data?.image_alt || ''} />
                </div>
            )}
        </section>
    );
}

export default FullWidthImageContent;